export enum KeyValue {
	Enter = "Enter",
	Escape = "Escape",
}

// Physical key positions, so a shortcut keeps working on a non-QWERTY layout.
export enum KeyCode {
	F = "KeyF",
}
